import user from '../../Basics/User'
const god = {
  templateName: 'cardTemplateVip05',
  imgSrc: 'card/template/vip02/cardTemplateVip05.png',
  desc: '满月',
  category: 'card',
  vipGrade: 2,
  attr: {
    textColor: {
      type: 'color',
      id: '',
      label: '文本颜色',
      value: '#fff'
    },
    bgImage: {
      type: 'image',
      id: '',
      label: '背景图片',
      value: 'card/material/y.jpg'
    },
    modelSrc: {
      type: 'model',
      id: '',
      label: '上传模型',
      value: 'model/Lang.gltf'
    }
  }
}
god.attr = Object.assign(god.attr, user)
export default god
